module.exports = "<form>\n  <div class=\"form-group has-feedback\">\n    <input\n      type=\"text\"\n      class=\"form-control\"\n      placeholder=\"{{ 'FORM_SEARCH_PLACEHOLDER' | translate}}\"\n      ng-model=\"search.input\"\n      ng-change=\"search.$onChange()\"\n      ng-model-options=\"{debounce: 1000}\">\n    <span\n      class=\"glyphicon glyphicon-search form-control-feedback\"\n      aria-hidden=\"true\">\n    </span>\n  </div>\n</form>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/active/search/search.html
 ** module id = 195
 ** module chunks = 0
 **/